<div
  class="p-8 flex justify-center w-full mb-24"
  [ngClass]="{
    'bg-white text-black': promoStayInTouchFormData.theme === 'light',
  }"
  [ssDirectus]="{
    collection: 'promoStayInTouchForm',
    item: promoStayInTouchFormData.id,
    fields: ['theme'],
  }"
>
  <form
    class="flex grow flex-col gap-4 max-w-xl"
    [ngClass]="{
      'dark-form': promoStayInTouchFormData?.theme === 'dark',
    }"
    (ngSubmit)="onSubmit()"
    [formGroup]="form"
  >
    <ss-form-field label="Ministry / Organization (if applicable)">
      <input
        class="border-white! mt-1"
        ssInput
        formControlName="organization"
        ssBaseInput
      />
    </ss-form-field>
    <ss-form-field label="First Name">
      <input
        class="border-white! mt-1"
        ssInput
        formControlName="firstName"
        ssBaseInput
      />
    </ss-form-field>
    <ss-form-field label="Last Name">
      <input
        class="border-white! mt-1"
        ssInput
        formControlName="lastName"
        ssBaseInput
      />
    </ss-form-field>
    <ss-form-field label="Your Email Address">
      <input
        class="border-white! mt-1"
        ssInput
        ssForbiddenEmails
        formControlName="emailAddress"
        ssBaseInput
      />
      <ss-form-field-error forError="email"
        >Enter a valid email address
      </ss-form-field-error>
    </ss-form-field>
    <ss-form-field label="phone number">
      <input
        class="border-white! mt-1"
        ssInput
        ssDigitOnly
        formControlName="primaryPhone"
        type="tel"
        mask="(000) 000-0000"
        ssBaseInput
      />
      <ss-form-field-error forError="pattern"
        >Enter a valid email address
      </ss-form-field-error>
      <ss-form-field-error forError="maxlength"
        >Phone number max lenght is 20 characters
      </ss-form-field-error>
      <ss-form-field-error forError="minlength"
        >Phone number min lenght is 10 characters
      </ss-form-field-error>
    </ss-form-field>
    <ss-form-field label="street address">
      <input
        class="border-white! mt-1"
        ssInput
        formControlName="address"
        ssBaseInput
      />
    </ss-form-field>
    <ss-form-field label="City">
      <input
        class="border-white! mt-1"
        ssInput
        formControlName="city"
        ssBaseInput
      />
    </ss-form-field>
    <ss-form-field label="State">
      <input
        class="border-white! mt-1"
        ssInput
        formControlName="state"
        ssBaseInput
      />
      <ss-form-field-error forError="maxlength"
        >If your country is USA state should be 2 characters long.
      </ss-form-field-error>
    </ss-form-field>
    <ss-form-field class="max-w-[281px]" label="Zipcode">
      <input
        class="border-white! mt-1"
        ssInput
        formControlName="zipCode"
        ssBaseInput
      />
    </ss-form-field>
    @if (countries$ | async; as countries) {
      <ss-form-field label="Country">
        <ss-ui-select [data]="countries">
          <ss-ui-select-trigger
            ssInput
            formControlName="country"
            class="mt-1 border-white!"
          >
            Select your country
          </ss-ui-select-trigger>
        </ss-ui-select>
      </ss-form-field>
    }
    <div class="mt-5 w-72 mx-auto">
      <ss-button
        class="w-full"
        [disabled]="form.invalid"
        type="submit"
        buttonColor="principal"
        buttonStyle="filled"
        >Submit</ss-button
      >
    </div>
  </form>
</div>
